import { Accordion, AccordionDetails, AccordionSummary, useStyles } from './styles'
import React, { RefAttributes, useState } from 'react'

import Typography from '@material-ui/core/Typography'

interface Question {
    question: string
    answer: string
}

interface CategoryItemProps {
    category: string
    questionsList: Question[]
}

const getHtmlAnswer = (answer: string) => {
    return { __html: answer.replace(/(?:\r\n|\r|\n)/g, '<br>') }
}

type CombiedProps = CategoryItemProps & RefAttributes<HTMLDivElement>

const CategoryItem: React.FC<CombiedProps> = React.forwardRef(({ category, questionsList }, ref) => {
    const classes = useStyles()
    const [expanded, setExpanded] = useState<string | false>(false)

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false)
    }

    return (
        <div className={classes.list} ref={ref} id={category}>
            <Typography variant="h6" gutterBottom>
                {category}
            </Typography>
            {questionsList.map((q, index) => (
                <Accordion
                    key={`support-${index}`}
                    square
                    expanded={expanded === `support-${index}`}
                    onChange={handleChange(`support-${index}`)}
                >
                    <AccordionSummary aria-controls={`support-${index}-content`} id={`support-${index}-header`}>
                        <Typography>{q.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography component="div">
                            <div dangerouslySetInnerHTML={getHtmlAnswer(q.answer)} />
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            ))}
        </div>
    )
})

export default React.memo(CategoryItem)
